export enum TransactionType {
    deposit = 1,
    withdraw = 2,
    payment = 5,
    transfer = 8
}
